// Copyright (c) 2022 by Move Closer

import isPlainObject from 'lodash/isPlainObject'

import { isRelated } from '../../../contexts'
import { UnresolvedLink } from './LinkForm.contracts'

/**
 * Determines whether the passed-in object correctly implements the `UnresolvedLink` interface.
 *
 * @typeGuard
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isUnresolvedLink = (subject: any): subject is UnresolvedLink => {
  if (!isPlainObject(subject)) {
    return false
  }

  return isRelated(subject.relatedTarget)
}
